import { render, staticRenderFns } from "./Lightning_delivery.vue?vue&type=template&id=625b2e52&scoped=true"
import script from "./Lightning_delivery.vue?vue&type=script&lang=js"
export * from "./Lightning_delivery.vue?vue&type=script&lang=js"
import style0 from "./Lightning_delivery.vue?vue&type=style&index=0&id=625b2e52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625b2e52",
  null
  
)

export default component.exports